/* KÔBO — accueil : hero particules → panneau blanc → timeline de scroll (GSAP + ScrollTrigger + Lenis) */
(function () {
  var root = document.getElementById('k-home');
  if (!root || !window.gsap || !window.ScrollTrigger) return;
  var gsap = window.gsap, ScrollTrigger = window.ScrollTrigger;
  gsap.registerPlugin(ScrollTrigger);
  ScrollTrigger.config({ ignoreMobileResize: true, limitCallbacks: true });
  gsap.ticker.lagSmoothing(0);

  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var isDesk = function () { return window.innerWidth >= 1024; };
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var HEADER = function () { return isDesk() ? 80 : 72; };

  document.documentElement.classList.add('k-home');

  var hero = $('#k-hero'), cvs = $('#k-part'), panel = $('#k-panel'), inner = $('#k-panel-in');
  var chev = $('#k-chev'), loader = $('#k-loader'), hint = $('#k-hero-hint');
  var logoBox = $('.k-b-logo'), logoText = $('#k-logo-text');
  var phase = 'hero', busy = false, lenis = null, triggers = [], built = false, grain = null;

  /* logo SVG : mêmes glyphes que les particules */
  function fitLogo() {
    var wpx = window.innerWidth <= 768 ? 138 : (window.innerWidth >= 1024 ? 320 : Math.min(600, 0.8 * window.innerWidth));
    logoBox.style.width = wpx + 'px'; logoBox.style.height = Math.round(wpx * 176.8 / 624.3) + 'px';
  }
  fitLogo(); window.addEventListener('resize', fitLogo);

  /* footer du thème → dans le panneau */
  var foot = document.querySelector('.shopify-section-group-footer-group');
  var slot = $('#k-foot-slot');
  if (foot && slot) slot.appendChild(foot);

  gsap.set(panel, { yPercent: 100 });
  panel.style.visibility = 'visible';

  /* ==================================================================
     HÉROS : simulation de fluide + particules (port du moteur de la maquette)
     - grille de cellules 10px (vitesse + pression), vent ambiant
     - la souris injecte de la vitesse, les particules la suivent puis reviennent au logo (ressort)
     - entrée « windGather » : les particules arrivent du côté droit en tourbillonnant
  ================================================================== */
  var GLYPHS = [
    'M113.4 277.5H167.5L118.7 333.5L168.5 413.5H116.9L88.6 363.7L64.9 383.1V413.5H21.2V277.5H64.9V335.6Z',
    'M327.0 345.5Q327.0 379.9 307.9 397.9Q288.7 415.9 253.5 415.9Q218.3 415.9 199.2 398.0Q180.2 380.1 180.2 345.5Q180.2 310.9 199.2 293.0Q218.3 275.2 253.5 275.2Q288.7 275.2 307.9 293.1Q327.0 311.1 327.0 345.5ZM224.8 339.2V351.8Q224.8 366.3 232.2 374.8Q239.5 383.3 253.5 383.3Q267.5 383.3 275.0 374.8Q282.4 366.3 282.4 351.8V339.2Q282.4 324.8 275.0 316.3Q267.5 307.8 253.5 307.8Q239.5 307.8 232.2 316.3Q224.8 324.8 224.8 339.2Z',
    'M478.7 310.9Q478.7 336.0 455.9 342.6V343.3Q481.8 349.3 481.8 377.3Q481.8 388.0 476.6 396.2Q471.3 404.4 462.3 409.0Q453.2 413.5 442.3 413.5H350.6V277.5H441.1Q451.4 277.5 460.0 281.8Q468.6 286.0 473.6 293.7Q478.7 301.4 478.7 310.9ZM394.3 330.5H424.3Q428.6 330.5 431.5 327.4Q434.4 324.4 434.4 319.8V317.8Q434.4 313.5 431.4 310.4Q428.4 307.4 424.3 307.4H394.3ZM394.3 381.9H427.5Q431.8 381.9 434.7 378.8Q437.5 375.8 437.5 371.2V369.2Q437.5 364.7 434.7 361.6Q431.8 358.6 427.5 358.6H394.3Z',
    'M645.5 345.5Q645.5 379.9 626.3 397.9Q607.1 415.9 572.0 415.9Q536.8 415.9 517.7 398.0Q498.6 380.1 498.6 345.5Q498.6 310.9 517.7 293.0Q536.8 275.2 572.0 275.2Q607.1 275.2 626.3 293.1Q645.5 311.1 645.5 345.5ZM543.3 339.2V351.8Q543.3 366.3 550.6 374.8Q557.9 383.3 572.0 383.3Q586.0 383.3 593.4 374.8Q600.8 366.3 600.8 351.8V339.2Q600.8 324.8 593.4 316.3Q586.0 307.8 572.0 307.8Q557.9 307.8 550.6 316.3Q543.3 324.8 543.3 339.2Z',
    'M267.9 266.8L253.5 252.3L239.1 266.8H213.8L241.5 239.1H266.7L294.4 266.8Z'
  ];
  var GB = { x: 21.2, y: 239.1, w: 624.3, h: 176.8 };   /* boîte englobante des glyphes */

  var P = (function () {
    var ctx = cvs.getContext('2d'), dpr = Math.min(window.devicePixelRatio || 1, 2);
    var W = 0, H = 0, CELL = 10, cols = 0, rows = 0, VX, VY, PR, pts = [], N = 0;
    var mouse = { x: -9999, y: -9999, px: -9999, py: -9999 }, tilt = { tx: 0, ty: 0, cx: 0, cy: 0 };
    var state = 'entrance', tStart = 0, tMorph = 0, colorMix = 0, colorTarget = 0, lastT = performance.now() / 1000;
    var logoCb = null, alive = true, sz = 1, built = false;
    var SX, SY, DELAY, DUR, WOB;   /* données d'entrée */

    var vAt = function (A, c, r) { return (c < 0 || r < 0 || c >= cols || r >= rows) ? 0 : A[r * cols + c]; };

    function buildGrid() { cols = Math.ceil(W / CELL); rows = Math.ceil(H / CELL); var n = cols * rows; VX = new Float32Array(n); VY = new Float32Array(n); PR = new Float32Array(n); }

    function sampleHero() {
      /* mobile = CPU la plus faible : échantillonnage plus large (moins de
         particules), pas plus dense qu’en desktop comme c’était le cas avant. */
      var mob = W < 1024, ss = mob ? 1.15 : 1.2;
      var r = Math.floor(W * ss), a = Math.floor(H * ss);
      var c = document.createElement('canvas'); c.width = r; c.height = a;
      var g = c.getContext('2d', { willReadFrequently: true });
      var sc = mob ? 0.8 : 0.6, o = Math.min(r * sc / 661, a * sc / 695);
      var lx = r / 2 - 330.5 * o, ly = a / 2 - 347.5 * o;
      g.fillStyle = '#000'; g.fillRect(0, 0, r, a); g.fillStyle = '#fff'; g.save(); g.translate(lx, ly); g.scale(o, o);
      GLYPHS.forEach(function (d) { g.fill(new Path2D(d)); }); g.restore();
      var data = g.getImageData(0, 0, r, a).data, out = [], st = mob ? 3 : 2;
      for (var y = 0; y < a; y += st) for (var x = 0; x < r; x += st) if (data[(y * r + x) * 4] > 128) out.push({ x: (x + (Math.random() - 0.5) * st) / ss, y: (y + (Math.random() - 0.5) * st) / ss });
      var cap = mob ? 26000 : 140000;
      if (out.length > cap) { for (var i = out.length - 1; i > 0; i--) { var j = Math.random() * (i + 1) | 0, t = out[i]; out[i] = out[j]; out[j] = t; } out.length = cap; }
      return out;
    }

    function logoBoxPx() { var l = W <= 768 ? 138 : (W >= 1024 ? 320 : Math.min(600, 0.8 * W)); return { w: l, h: GB.h * l / GB.w, x: (W - l) / 2, y: Math.round(H * 0.75) }; }

    var TX, TY, IS_TEXT;   /* cible « logo » de chaque particule */
    function sampleLogo() {
      var b = logoBoxPx(), pw = Math.ceil(b.w), ph = Math.ceil(b.h);
      var c = document.createElement('canvas'); c.width = pw; c.height = ph;
      var g = c.getContext('2d', { willReadFrequently: true });
      var s = pw / GB.w; g.fillStyle = '#000'; g.fillRect(0, 0, pw, ph); g.fillStyle = '#fff'; g.save(); g.scale(s, s); g.translate(-GB.x, -GB.y);
      GLYPHS.forEach(function (d) { g.fill(new Path2D(d)); }); g.restore();
      var data = g.getImageData(0, 0, pw, ph).data, lp = [];
      for (var y = 0; y < ph; y += 1) for (var x = 0; x < pw; x += 1) if (data[(y * pw + x) * 4] > 128) lp.push({ rx: (x + (Math.random() - 0.5) * 0.6) / pw, ry: (y + (Math.random() - 0.5) * 0.6) / ph });
      TX = new Float32Array(N); TY = new Float32Array(N); IS_TEXT = new Uint8Array(N);
      if (!lp.length || !N) return;
      var idxP = pts.map(function (_, i) { return i; }).sort(function (a, b2) { return pts[a].lx - pts[b2].lx || pts[a].ly - pts[b2].ly; });
      var idxL = lp.map(function (_, i) { return i; }).sort(function (a, b2) { return lp[a].rx - lp[b2].rx || lp[a].ry - lp[b2].ry; });
      var np = idxP.length, nl = idxL.length, M = Math.min(np, nl);
      for (var k = 0; k < nl && k < 1e9; k++) { var pi = idxP[Math.floor(k * np / nl)]; IS_TEXT[pi] = 1; var L = lp[idxL[k]]; TX[pi] = b.x + L.rx * b.w; TY[pi] = b.y + L.ry * b.h; }
      var texts = []; for (var t2 = 0; t2 < N; t2++) if (IS_TEXT[t2]) texts.push(t2);
      for (var q = 0; q < N; q++) if (!IS_TEXT[q]) { var ref = texts[Math.floor(Math.random() * texts.length)]; TX[q] = TX[ref] + (Math.random() - 0.5); TY[q] = TY[ref] + (Math.random() - 0.5); }
    }

    function initEntrance() {
      SX = new Float32Array(N); SY = new Float32Array(N); DELAY = new Float32Array(N); DUR = new Float32Array(N); WOB = new Float32Array(N * 3);
      var minX = 1e9, maxX = -1e9; for (var i = 0; i < N; i++) { if (pts[i].lx < minX) minX = pts[i].lx; if (pts[i].lx > maxX) maxX = pts[i].lx; }
      for (var k = 0; k < N; k++) {
        var p = pts[k], n = (p.lx - minX) / ((maxX - minX) || 1);
        var e = 0.7 * W + Math.random() * W * 0.3, tt = (Math.random() - 0.5) * H * 0.6;
        SX[k] = p.lx + e; SY[k] = p.ly + tt; DELAY[k] = 0.3 + 1.8 * n + 0.2 * Math.random(); DUR[k] = 1.6 + 0.6 * Math.random();
        WOB[3 * k] = 20 + 35 * Math.random(); WOB[3 * k + 1] = 2 + 3 * Math.random(); WOB[3 * k + 2] = Math.random() * Math.PI * 2;
        p.x = p.px = SX[k]; p.y = p.py = SY[k]; p.vx = p.vy = 0; p.ox = p.lx; p.oy = p.ly; p.ret = null; p.al = 1;
      }
      state = 'entrance'; tStart = performance.now() / 1000;
    }

    function build() {
      W = window.innerWidth; H = window.innerHeight;
      cvs.width = Math.round(W * dpr); cvs.height = Math.round(H * dpr); sz = Math.max(1, Math.round((W <= 1024 ? 0.5 : 0.8) * dpr));
      buildGrid();
      var s = sampleHero(); N = s.length; pts = new Array(N);
      for (var i = 0; i < N; i++) pts[i] = { lx: s[i].x, ly: s[i].y, x: s[i].x, y: s[i].y, px: s[i].x, py: s[i].y, ox: s[i].x, oy: s[i].y, vx: 0, vy: 0, ret: null, al: 1, rfx: 0, rfy: 0 };
      sampleLogo();
      var was = state; initEntrance(); if (built) { state = 'hero'; for (var j = 0; j < N; j++) { pts[j].x = pts[j].lx; pts[j].y = pts[j].ly; } } built = true;
    }

    function ambient(t) { var n = 0.06 * t; for (var r = 0; r < rows; r++) for (var c = 0; c < cols; c++) { var i = r * cols + c; VX[i] += 0.005 * Math.sin(0.005 * (r * CELL) + n); VY[i] += 0.005 * Math.cos(0.005 * (c * CELL) - 1.1 * n); } }

    function inject(x0, y0, x1, y1, dx, dy) {
      var steps = Math.max(1, Math.ceil(Math.hypot(x1 - x0, y1 - y0) / 6));
      for (var s = 0; s <= steps; s++) {
        var l = s / steps, mx = x0 + (x1 - x0) * l, my = y0 + (y1 - y0) * l;
        var c0 = Math.max(0, (mx - 48) / CELL | 0), c1 = Math.min(cols - 1, (mx + 48) / CELL | 0), r0 = Math.max(0, (my - 48) / CELL | 0), r1 = Math.min(rows - 1, (my + 48) / CELL | 0);
        for (var c = c0; c <= c1; c++) for (var r = r0; r <= r1; r++) {
          var d = Math.hypot(c * CELL - mx, r * CELL - my);
          if (d < 48) { if (d < 4) d = 48; var f = 48 / d, i = r * cols + c; VX[i] += dx * f; VY[i] += dy * f; }
        }
      }
    }

    function fluid() {
      var c, r, i, t, n;
      for (r = 0; r < rows; r++) for (c = 0; c < cols; c++) {
        t = 0.5 * vAt(VX, c - 1, r - 1) + vAt(VX, c - 1, r) + 0.5 * vAt(VX, c - 1, r + 1) - 0.5 * vAt(VX, c + 1, r - 1) - vAt(VX, c + 1, r) - 0.5 * vAt(VX, c + 1, r + 1);
        n = 0.5 * vAt(VY, c - 1, r - 1) + vAt(VY, c, r - 1) + 0.5 * vAt(VY, c + 1, r - 1) - 0.5 * vAt(VY, c - 1, r + 1) - vAt(VY, c, r + 1) - 0.5 * vAt(VY, c + 1, r + 1);
        PR[r * cols + c] = (t + n) * 0.25;
      }
      for (r = 0; r < rows; r++) for (c = 0; c < cols; c++) {
        i = r * cols + c;
        VX[i] += (0.5 * vAt(PR, c - 1, r - 1) + vAt(PR, c - 1, r) + 0.5 * vAt(PR, c - 1, r + 1) - 0.5 * vAt(PR, c + 1, r - 1) - vAt(PR, c + 1, r) - 0.5 * vAt(PR, c + 1, r + 1)) * 0.25;
        VY[i] += (0.5 * vAt(PR, c - 1, r - 1) + vAt(PR, c, r - 1) + 0.5 * vAt(PR, c + 1, r - 1) - 0.5 * vAt(PR, c - 1, r + 1) - vAt(PR, c, r + 1) - 0.5 * vAt(PR, c + 1, r + 1)) * 0.25;
        var m = Math.hypot(VX[i], VY[i]); if (m > 100) { var k = 100 / m; VX[i] *= k; VY[i] *= k; }
        VX[i] *= 0.99; VY[i] *= 0.99;
      }
    }

    function particles(now, dt) {
      for (var i = 0; i < N; i++) {
        var p = pts[i], s = Math.hypot(p.vx, p.vy);
        if (s > 0.5) p.ret = null; else if (p.ret === null) p.ret = now;
        if (p.ret !== null) { var q = Math.min(1, (now - p.ret) / 0.05), sm = q * q * (3 - 2 * q), f = 50 * dt * (0.15 + 0.85 * sm); p.vx += (p.ox - p.x) * f; p.vy += (p.oy - p.y) * f; }
      }
      for (var k = 0; k < N; k++) {
        var a = pts[k], X = Math.min(Math.max(a.x, 0), W), Y = Math.min(Math.max(a.y, 0), H);
        var c = Math.min(cols - 1, Math.max(0, X / CELL | 0)), r = Math.min(rows - 1, Math.max(0, Y / CELL | 0));
        var u = r * cols + c, dx = ((a.x % CELL) + CELL) % CELL / CELL, dy = ((a.y % CELL) + CELL) % CELL / CELL;
        var R = c + 1 < cols ? u + 1 : u, D = r + 1 < rows ? u + cols : u;
        a.vx += (1 - dx) * VX[u] * 0.06 + dx * VX[R] * 0.06 + dy * VX[D] * 0.06;
        a.vy += (1 - dy) * VY[u] * 0.06 + dx * VY[R] * 0.06 + dy * VY[D] * 0.06;
        var m = Math.hypot(a.vx, a.vy); if (m > 30) { var f2 = 30 / m; a.vx *= f2; a.vy *= f2; }
        a.x += a.vx; a.y += a.vy; a.vx *= 0.4; a.vy *= 0.4;
      }
    }

    function draw() {
      ctx.clearRect(0, 0, cvs.width, cvs.height);
      var ca = Math.cos(tilt.cx * 0.1396), sa = Math.sin(tilt.cx * 0.1396), cb = Math.cos(tilt.cy * 0.1396), sb = Math.sin(tilt.cy * 0.1396), cx = W / 2, cy = H / 2;
      var v = Math.round(255 * (1 - colorMix)), col = 'rgb(' + v + ',' + v + ',' + v + ')', dark = colorMix > 0.5;
      ctx.fillStyle = col;
      var lastA = -1;
      for (var i = 0; i < N; i++) {
        var p = pts[i]; if (p.al <= 0.01) continue;
        var dx = p.x - cx, dy = p.y - cy, x1 = dx * ca, z1 = dx * sa, y2 = dy * cb, z2 = z1 + dy * sb, sc = H / (H - z2);
        var X = (cx + x1 * sc) * dpr, Y = (cy + y2 * sc) * dpr;
        if (p.al !== lastA) { ctx.globalAlpha = p.al; lastA = p.al; }
        ctx.fillRect(X | 0, Y | 0, sz, sz);
      }
      ctx.globalAlpha = 1;
    }

    function step(now) {
      requestAnimationFrame(step);
      if (!alive || !N) return;
      var t = now / 1000, dt = Math.min(0.05, t - lastT); lastT = t;
      tilt.cx += (tilt.tx - tilt.cx) * 0.08; tilt.cy += (tilt.ty - tilt.cy) * 0.08;
      colorMix += Math.abs(colorTarget - colorMix) < 0.01 ? colorTarget - colorMix : 0.08 * (colorTarget - colorMix);
      var i;
      if (state === 'entrance') {
        var s = t - tStart, done = true;
        for (i = 0; i < N; i++) {
          var p = pts[i], a = s - DELAY[i]; if (a < 0) { done = false; continue; }
          var l = Math.min(1, a / DUR[i]); if (l < 1) done = false;
          var e = l === 1 ? 1 : 1 - Math.pow(2, -10 * l), sx = SX[i], sy = SY[i];
          p.x = sx + (p.lx - sx) * e; p.y = sy + (p.ly - sy) * e;
          var w = Math.sin(l * WOB[3 * i + 1] * Math.PI + WOB[3 * i + 2]) * WOB[3 * i] * (1 - l), ox = p.lx - sx, oy = p.ly - sy, d = Math.sqrt(ox * ox + oy * oy) || 1;
          p.x += -oy / d * w; p.y += ox / d * w; p.vx = p.vy = 0;
        }
        if (done) { for (i = 0; i < N; i++) { var q = pts[i]; q.x = q.px = q.lx; q.y = q.py = q.ly; q.vx = q.vy = 0; } state = 'hero'; VX.fill(0); VY.fill(0); PR.fill(0); }
        mouse.px = mouse.x; mouse.py = mouse.y; draw(); return;
      }
      if (state === 'toLogo') {
        var e1 = Math.min(1, (t - tMorph) / 0.8), s1 = 1 - Math.pow(1 - e1, 3);
        for (i = 0; i < N; i++) { var a1 = pts[i]; a1.x = a1.rfx + (TX[i] - a1.rfx) * s1; a1.y = a1.rfy + (TY[i] - a1.rfy) * s1; a1.al = IS_TEXT[i] ? 1 : (e1 > 0.6 ? 1 - (e1 - 0.6) / 0.4 : 1); }
        if (logoCb) logoCb(e1 > 0.6 ? (e1 - 0.6) / 0.4 : 0);
        draw(); if (e1 >= 1) { state = 'logo'; for (i = 0; i < N; i++) pts[i].al = 0; ctx.clearRect(0, 0, cvs.width, cvs.height); if (logoCb) logoCb(1); }
        return;
      }
      if (state === 'logo') return;
      if (state === 'fromLogo') {
        var e2 = Math.min(1, (t - tMorph) / 0.8), s2 = 1 - Math.pow(1 - e2, 3);
        for (i = 0; i < N; i++) { var b = pts[i]; b.x = b.rfx + (b.ox - b.rfx) * s2; b.y = b.rfy + (b.oy - b.rfy) * s2; b.al = 1; }
        draw(); if (e2 >= 1) { state = 'hero'; VX.fill(0); VY.fill(0); PR.fill(0); for (i = 0; i < N; i++) { pts[i].vx = pts[i].vy = 0; pts[i].ret = null; } }
        return;
      }
      /* état « hero » : fluide + ressort */
      var mdx = mouse.x - mouse.px, mdy = mouse.y - mouse.py;
      if ((mdx !== 0 || mdy !== 0) && mouse.x > -9000 && mouse.px > -9000) inject(mouse.px, mouse.py, mouse.x, mouse.y, mdx, mdy);
      ambient(t); fluid(); particles(t, dt);
      mouse.px = mouse.x; mouse.py = mouse.y;
      draw();
    }

    build();
    (document.fonts && document.fonts.ready ? document.fonts.ready : Promise.resolve()).then(function () { });
    var rt; window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(function () { var w = window.innerWidth, h = window.innerHeight; if (Math.abs(w - W) < 10 && Math.abs(h - H) < 150) return; var st = state; build(); if (st === 'logo') { state = 'logo'; for (var i = 0; i < N; i++) pts[i].al = 0; } }, 200); });
    window.addEventListener('mousemove', function (e) { mouse.px = mouse.x; mouse.py = mouse.y; mouse.x = e.clientX; mouse.y = e.clientY; tilt.tx = (e.clientX / W - 0.5) * 2; tilt.ty = (e.clientY / H - 0.5) * 2; }, { passive: true });
    document.addEventListener('mouseleave', function () { mouse.x = mouse.px = mouse.y = mouse.py = -9999; tilt.tx = tilt.ty = 0; });
    window.addEventListener('touchmove', function (e) { if (state !== 'hero') return; mouse.px = mouse.x; mouse.py = mouse.y; mouse.x = e.touches[0].clientX; mouse.y = e.touches[0].clientY; }, { passive: true });
    window.addEventListener('touchstart', function (e) { mouse.x = mouse.px = e.touches[0].clientX; mouse.y = mouse.py = e.touches[0].clientY; }, { passive: true });
    window.addEventListener('touchend', function () { mouse.x = mouse.px = mouse.y = mouse.py = -9999; }, { passive: true });
    requestAnimationFrame(step);
    return {
      restart: function () { initEntrance(); },
      onLogo: function (fn) { logoCb = fn; },
      toLogo: function () {
        if (state === 'toLogo' || state === 'logo') return;
        sampleLogo(); tMorph = performance.now() / 1000; colorTarget = 1;
        for (var i = 0; i < N; i++) { pts[i].rfx = pts[i].x; pts[i].rfy = pts[i].y; }
        state = 'toLogo';
      },
      fromLogo: function () {
        if (state === 'hero' || state === 'fromLogo') return;
        var texts = []; for (var i = 0; i < N; i++) if (IS_TEXT[i]) texts.push(i);
        for (var k = 0; k < N; k++) { var p = pts[k]; if (IS_TEXT[k]) { p.rfx = TX[k]; p.rfy = TY[k]; } else { var r = texts[Math.floor(Math.random() * texts.length)]; p.rfx = TX[r] + (Math.random() - 0.5) * 2; p.rfy = TY[r] + (Math.random() - 0.5) * 2; } p.al = 1; }
        tMorph = performance.now() / 1000; colorTarget = 0; state = 'fromLogo';
      },
      get state() { return state; },
      get ready() { return state === 'hero'; },
      logoBox: logoBoxPx,
      pause: function () { alive = false; },
      resume: function () { if (alive) return; alive = false; lastT = performance.now() / 1000; alive = true; }
    };
  })();

  /* ==================================================================
     GRAIN du fond blanc (3 canvas)
  ================================================================== */
  function makeGrain() {
    var host = $('.k-b-grain'); if (!host || host.__g) return; host.__g = 1;
    var bg = $('.k-b-bg');
    var w = host.offsetWidth || window.innerWidth, h = host.offsetHeight || window.innerHeight * 3;
    var mk = function () { var c = document.createElement('canvas'); c.width = w; c.height = h; c.style.cssText = 'position:absolute;top:0;left:0;width:100%;height:100%;pointer-events:none'; host.appendChild(c); return c; };
    var c1 = mk(), c2 = mk(), c3 = mk(), x3 = c3.getContext('2d');
    var clusters = []; for (var i = 0; i < 20; i++) clusters.push({ x: Math.random() * w, y: Math.random() * h, s: 40 + Math.random() * 300 });
    var gn = function () { var u = 0, v = 0; while (!u) u = Math.random(); while (!v) v = Math.random(); return Math.sqrt(-2 * Math.log(u)) * Math.cos(2 * Math.PI * v); };
    var fill = function (c, cfg) {
      var x = c.getContext('2d'), im = x.createImageData(c.width, c.height), d = im.data;
      for (var n = 0; n < cfg.count; n++) {
        var px, py;
        if (Math.random() < 0.6) { var cl = clusters[(Math.random() * clusters.length) | 0]; px = Math.round(cl.x + gn() * cl.s); py = Math.round(cl.y + gn() * cl.s); } else { px = (Math.random() * c.width) | 0; py = (Math.random() * c.height) | 0; }
        if (px < 0 || px >= c.width || py < 0 || py >= c.height) continue;
        var ix = (py * c.width + px) * 4; d[ix] = d[ix + 1] = d[ix + 2] = 80; d[ix + 3] = Math.min(255, d[ix + 3] + cfg.a0 + ((Math.random() * (cfg.a1 - cfg.a0)) | 0));
      }
      x.putImageData(im, 0, 0);
    };
    var dens = isDesk() ? 1 : 0.5;
    fill(c1, { count: 200000 * dens, a0: 10, a1: 60 }); fill(c2, { count: 110000 * dens, a0: 15, a1: 90 });
    var dots = []; for (var j = 0; j < 600 * dens; j++) { var cl2 = clusters[(Math.random() * clusters.length) | 0]; dots.push({ ox: Math.max(0, Math.min(w, cl2.x + gn() * cl2.s)), oy: Math.max(0, Math.min(h, cl2.y + gn() * cl2.s)), r: 0.5 + Math.random(), a: 0.06 + Math.random() * 0.22, ph: Math.random() * 6.28, sp: 0.012 * (0.5 + Math.random()), rx: 0, ry: 0 }); }
    var mx = 0, my = 0, tx = 0, ty = 0, mpx = -9999, mpy = -9999, sp = 0, sR = 0, running = false, raf = 0, t0 = performance.now();
    var wrapEl = bg.parentNode;
    var mm = function (e) { var r = wrapEl.getBoundingClientRect(); tx = (e.clientX - r.left - r.width / 2) / (r.width / 2); ty = (e.clientY - r.top - r.height / 2) / (r.height / 2); mpx = (e.clientX - r.left) / r.width * w; mpy = (e.clientY - r.top) / r.height * h; };
    wrapEl.addEventListener('mousemove', mm); wrapEl.addEventListener('mouseleave', function () { tx = ty = 0; mpx = mpy = -9999; });
    var draw = function (now) {
      if (!running) return; raf = requestAnimationFrame(draw);
      mx += (tx - mx) * 0.06; my += (ty - my) * 0.06;
      var s = (now - t0) / 1000, f = Math.min(1, (now - t0) / 2000);
      var a1 = 8 * Math.sin(0.2 * s) * f, a2 = 6 * Math.cos(0.15 * s) * f, b1 = 14 * Math.sin(0.28 * s + 1) * f, b2 = 10 * Math.cos(0.22 * s + 1) * f;
      c1.style.transform = 'translate3d(' + (10 * mx + a1).toFixed(1) + 'px,' + (10 * my + a2 - sp * sR * 0.4).toFixed(1) + 'px,0)';
      c2.style.transform = 'translate3d(' + (30 * mx + b1).toFixed(1) + 'px,' + (30 * my + b2 + sp * sR * (0.85 - 1)).toFixed(1) + 'px,0)';
      c3.style.transform = 'translate3d(' + (20 * mx).toFixed(1) + 'px,' + (20 * my).toFixed(1) + 'px,0)';
      x3.clearRect(0, 0, w, h);
      for (var i = 0; i < dots.length; i++) {
        var d = dots[i], ox = 8 * Math.sin(s * d.sp * 60 + d.ph), oy = 8 * Math.cos(s * d.sp * 42 + d.ph) * 0.7, X = d.ox + ox, Y = d.oy + oy, dx = X - mpx, dy = Y - mpy, dist = Math.sqrt(dx * dx + dy * dy);
        if (dist < 120 && dist > 0.1) { var q = (1 - dist / 120) * 60; d.rx += (dx / dist * q - d.rx) * 0.15; d.ry += (dy / dist * q - d.ry) * 0.15; } else { d.rx *= 0.92; d.ry *= 0.92; }
        x3.fillStyle = 'rgba(80,80,80,' + d.a.toFixed(3) + ')'; x3.beginPath(); x3.arc(X + d.rx, Y + d.ry, d.r, 0, 6.283); x3.fill();
      }
    };
    grain = {
      start: function () { if (!running) { running = true; t0 = performance.now(); raf = requestAnimationFrame(draw); } },
      stop: function () { running = false; cancelAnimationFrame(raf); },
      setParallax: function (p, r) { sp = p; sR = r; }
    };
  }

  /* ==================================================================
     TRANSITIONS
  ================================================================== */
  function initLenis() {
    if (lenis || !window.Lenis || !isDesk() || reduce) return;
    lenis = new window.Lenis({ wrapper: panel, content: inner, smoothWheel: true, syncTouch: true, duration: 0.8, easing: function (t) { return t === 1 ? 1 : 1.001 - Math.pow(2, -10 * t); } });
    lenis.on('scroll', ScrollTrigger.update);
    gsap.ticker.add(lenisRaf);
  }
  function lenisRaf(t) { if (lenis) lenis.raf(t * 1000); }
  function killLenis() { if (!lenis) return; gsap.ticker.remove(lenisRaf); lenis.destroy(); lenis = null; panel.scrollTop = 0; }

  function toWhite() {
    if (busy || phase !== 'hero') return;
    busy = true;
    var hdr = HEADER();
    logoBox.style.top = Math.round(0.75 * window.innerHeight - hdr) + 'px';
    gsap.set(logoBox, { opacity: 0 });
    panel.style.overflowY = 'hidden';
    if (hint) gsap.to(hint, { opacity: 0, duration: 0.2 });
    gsap.to(chev, { opacity: 0, duration: 0.2 });
    P.onLogo(function (v) { logoBox.style.opacity = v; });
    P.toLogo();
    gsap.fromTo(panel, { yPercent: 100 }, {
      yPercent: 0, duration: reduce ? 0.01 : 0.8, ease: 'power3.out',
      onComplete: function () {
        logoBox.style.opacity = 1;
        gsap.to(cvs, { opacity: 0, duration: 0.2 });
        phase = 'landing'; busy = false; panel.scrollTop = 0;
        makeGrain(); if (grain) grain.start();
        if (!isDesk()) setTimeout(toContent, 350);
      }
    });
  }

  function toContent() {
    if (busy || phase !== 'landing') return;
    busy = true;
    var hdr = HEADER();
    var tl = gsap.timeline({
      onComplete: function () {
        busy = false; phase = 'content';
        panel.style.overflowY = 'auto'; panel.scrollTop = 0;
        initLenis(); buildScroll(); ScrollTrigger.refresh();
      }
    });
    tl.to(logoBox, { top: Math.round(0.25 * window.innerHeight - hdr) + 'px', duration: 0.6, ease: 'power3.out' });
    tl.fromTo('.k-dash1', { clipPath: 'inset(0 0 100% 0)' }, { clipPath: 'inset(0 0 0% 0)', duration: 0.5 }, 0.3);
    tl.fromTo('.k-bimg', { opacity: 0, y: 30 }, { opacity: 1, y: 0, duration: 0.4 }, 0.4);
    tl.fromTo('.k-btext', { opacity: 0, y: 20 }, { opacity: 1, y: 0, duration: 0.4 }, 0.5);
  }

  function toHero() {
    if (busy || phase === 'hero') return;
    if (phase === 'content' && panel.scrollTop > 5) return;
    busy = true;
    killLenis(); killScroll();
    panel.style.overflowY = 'hidden'; panel.scrollTop = 0;
    var hdr = HEADER();
    logoBox.style.top = Math.round(0.75 * window.innerHeight - hdr) + 'px';
    gsap.set('.k-dash', { clipPath: 'inset(0 0 100% 0)' });
    gsap.set('.k-bimg', { opacity: 0, y: 30 }); gsap.set('.k-btext', { opacity: 0, y: 20 });
    gsap.set('.k-bslogan', { opacity: 0, y: 20 }); gsap.set('.k-bimg2', { opacity: 0, y: 30 });
    gsap.set('.k-b-content', { y: 0 }); gsap.set('.k-b-bg', { y: 0 });
    gsap.set('.kobo-line-path', { strokeDasharray: '0 9999' }); gsap.set('.line-start-dot,.line-end-arrow', { opacity: 0 });
    gsap.set('.line-label', { opacity: 0, y: 8 }); gsap.set('.k-line-slogan', { opacity: 0, y: 12 });
    gsap.set(logoBox, { opacity: 0 });
    gsap.set(cvs, { opacity: 1 }); P.onLogo(null); P.fromLogo();
    if (grain) grain.stop();
    gsap.to(chev, { opacity: 0.8, duration: 0.4, delay: 0.5 });
    gsap.to(panel, {
      yPercent: 100, duration: 0.8, ease: 'power3.out',
      onComplete: function () { phase = 'hero'; busy = false; }
    });
  }

  /* ==================================================================
     TIMELINES de scroll (dans le panneau)
  ================================================================== */
  function killScroll() { triggers.forEach(function (t) { try { t.kill(); } catch (e) {} }); triggers = []; built = false; }

  function buildScroll() {
    if (built) return; built = true;
    var wrapper = $('#k-brand'), content = $('.k-b-content'), bg = $('.k-b-bg');
    var slogan = $('.k-bslogan'), dash2 = $('.k-dash2'), dash1 = $('.k-dash1'), img2 = $('.k-bimg2'), bottom = $('.k-bbottom'), svg = $('.k-path-svg'), strip = $('.k-line-slogan');
    var path = $('.kobo-line-path');
    var w = bottom.offsetTop + bottom.offsetHeight, vh = window.innerHeight, S = window.innerWidth > 1024 ? 200 : 100;
    var j = -(slogan.offsetTop - S);
    bottom.style.paddingBottom = '';
    var e0 = w + j; if (e0 < vh) { bottom.style.paddingBottom = Math.ceil(vh - e0) + 'px'; w = bottom.offsetTop + bottom.offsetHeight; }
    var T = w + 90;
    var R = -(bg.offsetHeight - bg.parentElement.offsetHeight);
    wrapper.style.height = window.innerHeight + T + 'px';

    var tl = gsap.timeline({
      scrollTrigger: {
        trigger: wrapper, scroller: panel, start: 'top top', end: 'bottom bottom', scrub: true,
        onUpdate: function (s) { if (grain) grain.setParallax(s.progress, R); },
        onLeave: function () { if (grain) grain.stop(); }, onEnterBack: function () { if (grain) grain.start(); }
      }
    });
    tl.to(content, { y: j, duration: 0.25, ease: 'none' });
    tl.fromTo(dash2, { clipPath: 'inset(0 0 100% 0)' }, { clipPath: 'inset(0 0 0% 0)', duration: 0.2 }, '<');
    tl.fromTo(slogan, { opacity: 0, y: 20 }, { opacity: 1, y: 0, duration: 0.15 }, '-=0.1');
    tl.fromTo(img2, { opacity: 0, y: 30 }, { opacity: 1, y: 0, duration: 0.15 });

    var E = -(w - vh);
    if (path) {
      var len = path.getTotalLength(), prog = { v: 0 };
      var setDash = function (f) {
        var r = f * len, n = len - r + 10;
        if (r <= 0) { path.style.strokeDasharray = '0 ' + (len + 10); return; }
        var q = Math.floor(r / 4), rem = r - 4 * q, pat = '2 2 '.repeat(q);
        if (rem > 2) pat += '2 ' + (rem - 2) + ' '; else if (rem > 0) pat += rem + ' 0 ';
        pat += '0 ' + n; path.style.strokeDasharray = pat;
      };
      setDash(0);
      var arrow = $('.line-end-arrow'), p1 = path.getPointAtLength(len - 2), p2 = path.getPointAtLength(len);
      var ang = Math.atan2(p2.y - p1.y, p2.x - p1.x) * 180 / Math.PI, sc = window.innerWidth > 1024 ? 0.8 : 1;
      arrow.setAttribute('transform', 'rotate(' + (ang - 90) + ', ' + p2.x + ', ' + p2.y + ') translate(' + p2.x + ', ' + p2.y + ') scale(' + sc + ') translate(' + (-p2.x) + ', ' + (-p2.y) + ')');
      tl.to('.line-start-dot', { opacity: 1, duration: 0.03 });
      tl.to(prog, { v: 1, duration: 0.35, ease: 'none', onUpdate: function () { setDash(prog.v); } });
      var mid = Math.min(Math.max(-(img2.offsetTop + img2.offsetHeight / 2), E), j);
      tl.to(content, { y: mid, duration: 0.35, ease: 'none' }, '<');
      tl.to('.line-end-arrow', { opacity: 1, duration: 0.03 });
      for (var i = 1; i <= 5; i++) {
        var lab = $$('.line-label')[i - 1]; if (!lab) continue;
        tl.fromTo(lab, { opacity: 0, y: 8 }, { opacity: 1, y: 0, duration: 0.04 }, i > 1 ? '-=0.01' : undefined);
      }
      if (strip) tl.fromTo(strip, { opacity: 0, y: 12 }, { opacity: 1, y: 0, duration: 0.06, ease: 'power2.out' });
    }
    if (E < -(img2.offsetTop + img2.offsetHeight / 2)) tl.to(content, { y: E, duration: 0.15, ease: 'none' });
    var z = tl.duration();
    tl.to({}, { duration: 90 / (T - 90) * z });
    var total = tl.duration();
    tl.fromTo(bg, { y: 0 }, { y: R, duration: total, ease: 'none' }, 0);
    triggers.push(tl.scrollTrigger);

    /* --- image plein écran qui se réduit --- */
    var fw = $('.k-feat-wrap'), clip = $('.k-feat-clip');
    var mob = window.innerWidth < 1024, extra = mob ? 0.7 * window.innerHeight : 2 * window.innerHeight;
    fw.style.height = window.innerHeight + extra + 'px';
    var ft = gsap.timeline({ scrollTrigger: { trigger: fw, scroller: panel, start: 'top top', end: 'bottom bottom', scrub: true } });
    if (mob) ft.to('.k-feat-img', { scale: 0.7, y: -100, transformOrigin: 'center top', duration: 1 });
    else { ft.to('.k-feat-img', { scale: 0.6, duration: 1 }); ft.to(clip, { clipPath: 'inset(20% 25% 20% 25%)', duration: 1 }, 0); }
    var flogo = $('.k-feat-logo');
    if (flogo) ft.fromTo(flogo, { opacity: 0, y: 15 }, { opacity: 1, y: 0, duration: 0.3 }, 0.5);
    triggers.push(ft.scrollTrigger);

    /* --- galerie parallaxe --- */
    var items = $$('.k-gitem'), small = window.innerWidth < 768;
    var nx = small ? (window.innerWidth - items[0].offsetWidth) / 2 * 0.85 : 0;
    items.forEach(function (it, s) {
      var im = it.querySelector('img'), pw = it.parentElement.offsetWidth, l, h, c;
      if (small) { c = -Math.cos(2 * Math.PI * s / 12) * nx; l = 0; h = 0; }
      else { var mx = parseFloat(it.dataset.maxX) || 5; l = (parseFloat(getComputedStyle(it).getPropertyValue('--offset-x')) || 0) / 100 * pw; h = mx / 100 * pw; c = 0; }
      gsap.set(it, { x: small ? 0 : l });
      triggers.push(ScrollTrigger.create({
        trigger: it, scroller: panel, start: 'top bottom', end: 'bottom top', scrub: true,
        onUpdate: function (st) {
          var r = Math.sin(Math.PI * st.progress);
          gsap.set(it, small ? { x: r * c } : { x: l + r * h });
          gsap.set(it, { clipPath: 'inset(-1px ' + (20 - 20 * r) + '%)' });
        }
      }));
      var tw = gsap.fromTo(im, { scale: 1.5 }, { scale: 1, ease: 'none', scrollTrigger: { trigger: it, scroller: panel, start: 'top bottom', end: 'bottom top', scrub: true } });
      if (tw.scrollTrigger) triggers.push(tw.scrollTrigger);
    });
    var hs = items.map(function (n) { return n.offsetHeight; }), tops = items.map(function (n) { return n.offsetTop; }), gsec = $('.k-gallery');
    triggers.push(ScrollTrigger.create({
      trigger: gsec, scroller: panel, start: 'top bottom', end: 'bottom top',
      onUpdate: function () {
        var vh2 = window.innerHeight, mid2 = vh2 / 2, top = gsec.getBoundingClientRect().top;
        var sc2 = items.map(function (e, a) { return 1 + 0.15 * Math.max(0, Math.cos(Math.min(Math.abs(top + tops[a] + hs[a] / 2 - mid2) / (vh2 / 2), 1) * Math.PI / 2)); });
        var yy = Array(items.length).fill(0);
        for (var t = 1; t < items.length; t++) yy[t] = yy[t - 1] + hs[t - 1] * (sc2[t - 1] - 1) / 2 + hs[t] * (sc2[t] - 1) / 2;
        var avg = yy.reduce(function (a, b) { return a + b; }, 0) / yy.length;
        var op = items.map(function (e, a) { return 0.4 + 0.6 * Math.max(0, Math.cos(Math.min(Math.abs(top + tops[a] + hs[a] / 2 - mid2) / (vh2 / 2), 1) * Math.PI / 2)); });
        items.forEach(function (it, o) { gsap.set(it, { scale: sc2[o], y: yy[o] - avg, opacity: op[o] }); });
      }
    }));
    if (flogo) { /* révèle le logo quand la galerie approche */ }

    initMarquee();
    initSlider();
  }

  /* --- défilé produits --- */
  var marqDone = false;
  function initMarquee() {
    if (marqDone) return; marqDone = true;
    var wrap = $('.k-marq-wrap'), track = $('.k-marq-track'), inners = $$('.k-marq-inner');
    var seen = false;
    ScrollTrigger.create({ trigger: wrap, scroller: panel, start: 'top 95%', once: true, onEnter: function () {
      inners.forEach(function (n, i) { n.style.animationDelay = (0.04 * (i % 16)) + 's'; n.classList.add('k-in'); });
      setTimeout(function () { inners.forEach(function (n) { n.classList.remove('k-in'); n.classList.add('k-ready'); }); }, 2000);
    } });
    if (!window.matchMedia('(hover: hover)').matches) return;
    var flip = false;
    $$('.k-marq-item').forEach(function (it) {
      var inn = $('.k-marq-inner', it), tm = null;
      var ang = function () { var t = getComputedStyle(it).transform; if (!t || t === 'none') return 0; var m = t.match(/matrix\(([^)]+)\)/); if (!m) return 0; var p = m[1].split(',').map(Number); return 180 / Math.PI * Math.atan2(p[1], p[0]); };
      it.addEventListener('mouseenter', function () { clearTimeout(tm); tm = setTimeout(function () { var a = ang(), s = flip ? -30 : 30; flip = !flip; inn.style.transform = 'rotate(' + (s - a) + 'deg) scale(1.2)'; it.classList.add('has-hover'); track.classList.add('k-paused'); }, 120); });
      it.addEventListener('mouseleave', function () { clearTimeout(tm); inn.style.transform = ''; it.classList.remove('has-hover'); track.classList.remove('k-paused'); });
    });
  }

  /* --- slider collections --- */
  var sliderDone = false;
  function initSlider() {
    if (sliderDone) return; sliderDone = true;
    var sl = $('.k-slides'), dots = $('.k-dots'), slides = $$('.k-slide');
    if (!sl || slides.length < 2) return;
    slides.forEach(function (s, i) { var d = document.createElement('i'); d.addEventListener('click', function () { sl.scrollTo({ left: sl.clientWidth * i, behavior: 'smooth' }); }); dots.appendChild(d); });
    var upd = function () { var i = Math.round(sl.scrollLeft / sl.clientWidth); $$('i', dots).forEach(function (d, k) { d.classList.toggle('on', k === i); }); };
    sl.addEventListener('scroll', upd, { passive: true }); upd();
    var n = 0; setInterval(function () { if (phase === 'content' && document.hasFocus()) { n = (Math.round(sl.scrollLeft / sl.clientWidth) + 1) % slides.length; sl.scrollTo({ left: sl.clientWidth * n, behavior: 'smooth' }); } }, 5000);
  }

  /* ==================================================================
     ENTRÉES : molette / touch / clavier / clic
  ================================================================== */
  var gate = false;
  function lockBriefly() { gate = true; setTimeout(function () { gate = false; }, 200); }
  window.addEventListener('wheel', function (e) {
    if (gate) { e.preventDefault(); return; }
    if (phase === 'hero') { if (e.deltaY > 0) { e.preventDefault(); toWhite(); lockBriefly(); } return; }
    if (phase === 'landing') { e.preventDefault(); if (e.deltaY > 0) toContent(); else if (e.deltaY < 0) toHero(); lockBriefly(); return; }
    if (phase === 'content' && panel.scrollTop <= 0 && e.deltaY < 0) { e.preventDefault(); e.stopPropagation(); if (isDesk()) toHero(); }
  }, { passive: false, capture: true });
  var ty0 = 0, tt0 = 0;
  window.addEventListener('touchstart', function (e) { ty0 = e.touches[0].clientY; tt0 = performance.now(); }, { passive: true });
  window.addEventListener('touchend', function (e) {
    var dy = e.changedTouches[0].clientY - ty0, dt = performance.now() - tt0;
    if (phase === 'hero' && dy < -30) toWhite();
    else if (phase === 'landing') { if (dy < -30) toContent(); else if (dy > 30) toHero(); }
    else if (phase === 'content' && dy > 40 && panel.scrollTop <= 5) toHero();
  }, { passive: true });
  window.addEventListener('keydown', function (e) {
    if (phase === 'hero' && (e.key === 'ArrowDown' || e.key === ' ' || e.key === 'PageDown')) { e.preventDefault(); toWhite(); }
    else if (phase === 'landing' && (e.key === 'ArrowDown' || e.key === ' ')) { e.preventDefault(); toContent(); }
  });
  chev.addEventListener('click', toWhite);
  window.addEventListener('resize', function () { if (phase === 'content') { killScroll(); buildScroll(); ScrollTrigger.refresh(); } });

  /* ==================================================================
     ENTRÉE EN SCÈNE
  ================================================================== */
  function start() {
    gsap.to(loader, { opacity: 0, duration: 0.6, onComplete: function () { loader.classList.add('is-done'); } });
    P.restart();
    gsap.to(chev, { opacity: 0.8, duration: 0.6, delay: 2.4 });
    if (!isDesk() && hint) { hint.style.display = 'flex'; gsap.to(hint, { opacity: 1, duration: 0.5, delay: 2.2 }); }
  }
  var ready = (document.fonts && document.fonts.ready) ? document.fonts.ready : Promise.resolve();
  Promise.race([ready, new Promise(function (r) { setTimeout(r, 1500); })]).then(function () { setTimeout(start, 500); });

  /* ==================================================================
     ÉCONOMIE CPU : onglet caché -> on coupe le moteur de particules
     (sinon le canvas continue de tourner en arrière-plan, batterie/CPU
     gaspillés). Une fois l’écran d’accueil quitté (state === 'logo'),
     la boucle est déjà un no-op quasi gratuit, pas besoin d’un second
     mécanisme de pause basé sur la position de scroll.
  ================================================================== */
  document.addEventListener('visibilitychange', function () {
    if (document.hidden) P.pause(); else P.resume();
  });

  /* ---------- vidéo mascotte : chargée seulement à l’approche du viewport ---------- */
  var lazyVids = $$('[data-lazy-src]');
  if (lazyVids.length) {
    if ('IntersectionObserver' in window) {
      var vio = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (!e.isIntersecting) return;
          var v = e.target;
          v.src = v.getAttribute('data-lazy-src'); v.removeAttribute('data-lazy-src');
          v.load(); var pr = v.play(); if (pr && pr.catch) pr.catch(function () {});
          vio.unobserve(v);
        });
      }, { rootMargin: '600px 0px' });
      lazyVids.forEach(function (v) { vio.observe(v); });
    } else {
      lazyVids.forEach(function (v) { v.src = v.getAttribute('data-lazy-src'); });
    }
  }
})();
